<!--stuff to translate from component-->
<span class="cdk-visually-hidden" #invoiceDel i18n="@@sk-invoiceItemDeleted">Invoice item has been deleted</span>
<span class="cdk-visually-hidden" #success i18n="@@sk-success">Success</span>
<span class="cdk-visually-hidden" #archiveInvoice i18n="@@sk-archiveInvoice">Archive Invoice</span>
<span class="cdk-visually-hidden" #returnDashboard
      i18n="@@sk-returnInvoiceDashboard">Return to invoice dashboard</span>
<span class="cdk-visually-hidden" #shouldDelete i18n="@@sk-shouldDeleteInvoiceItem">Are you sure you want to delete this invoice item?</span>
<span class="cdk-visually-hidden" #yesText i18n="@@sk-yesText">yes</span>
<span class="cdk-visually-hidden" #noText i18n="@@sk-noText">no</span>
<ng-container>{{translate(invoiceDel.innerHTML, success.innerHTML, archiveInvoice.innerHTML, returnDashboard.innerHTML,
  shouldDelete.innerHTML, yesText.innerHTML, noText.innerHTML)}}</ng-container>
<!---->
<div *ngIf="!gotInvoiceDetail" i18n="@@sk-noInvoiceItems">
  There are no invoices items.
</div>

<table *ngIf="gotInvoiceDetail && onReady" mat-table class="sk-full-width-table" [dataSource]="dataSource" matSort
       aria-label="Elements">

  <!-- Location Column -->
  <ng-container matColumnDef="project">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-itemDescription">Item Description</th>
    <td mat-cell *matCellDef="let row">
      <span>{{row?.description}}</span>
    </td>
  </ng-container>

  <!-- Invoice Number -->
  <ng-container matColumnDef="item">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-invoiceItem">Invoice Item</th>
    <td mat-cell *matCellDef="let row">
      <div *ngIf="row?.invoiceType === 'Material'">
        <span *ngIf="row?.productId">{{ (productLookup[row?.productId]?.productName) }}</span>
        <span *ngIf="!row?.productId">{{row?.description}}</span>
      </div>
      <div *ngIf="row?.invoiceType !== 'Material'">
        <span>{{ serviceLookup[row?.serviceId]?.name }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-quantity">Quantity</th>
    <td mat-cell *matCellDef="let row">
      {{ row?.quantity }}
    </td>
  </ng-container>


  <!-- Invoice Tax -->
  <ng-container matColumnDef="unitPrice">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-amount">Amount</th>
    <td mat-cell *matCellDef="let row">
      {{ row?.unitPrice | customCurrency }}
    </td>
  </ng-container>


  <!-- Invoice Tax -->
  <ng-container matColumnDef="subtotal">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-subTotal">Subtotal</th>
    <td mat-cell *matCellDef="let row">
      {{ row?.invoiceSubtotal | customCurrency }}
    </td>
  </ng-container>

  <!-- Invoice Tax -->
  <ng-container matColumnDef="tax">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-tax">Tax</th>
    <td mat-cell *matCellDef="let row">
      {{ row?.invoiceTaxAmount | customCurrency }}
      <span class="mat-small">/
      {{ row?.salesTaxRate?.rate}}  %</span>
    </td>
  </ng-container>

  <!-- Invoice Total -->
  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@sk-total">Total</th>
    <td mat-cell *matCellDef="let row">
      {{ row?.invoiceTotal | customCurrency }}
    </td>
  </ng-container>

  <!-- Edit Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
    <td mat-cell *matCellDef="let row">
      <button mat-icon-button matTooltip="Edit invoice item"
              i18n-matTooltip="@@sk-editInvoiceItem"
              (click)="onEditItem(row)" matTooltipShowDelay="1000" matTooltipPosition="right">
        <mat-icon color="primary">edit</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Delete invoice item"
              i18n-matTooltip="@@sk-deleteInvoiceItem"
              (click)="onDeleteItem(row)" matTooltipShowDelay="1000"
              matTooltipPosition="right">
        <mat-icon color="primary">delete</mat-icon>
      </button>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;">
  </tr>

</table>

<mat-paginator
  [hidden]="!dataSource?.data.length"
  #paginator
  [length]="dataSource?.data.length"
  [pageIndex]="0"
  [pageSize]="10"
  [pageSizeOptions]="[10,25,50]">
</mat-paginator>
